import { Component, OnInit } from '@angular/core';
import { ApiService, UserInfo } from '../../services/api.service'
import { MenuService } from '../../services/menu.service'
import { AccountType } from '../../interfaces/api/AccountType'
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component'
import { ButtonComponent } from '@components/button/button.component'
import { TranslateModule } from '@ngx-translate/core'
import { NgForOf } from '@angular/common'

@Component({
    standalone: true,
    selector: 'app-other-services',
    templateUrl: './other-services.component.html',
    styleUrl: './other-services.component.scss',
    imports: [
        CosentinoSvgComponent,
        ButtonComponent,
        TranslateModule,
        NgForOf
    ]
})
export class OtherServicesComponent implements OnInit {
    userInfo: UserInfo;

    constructor(private api: ApiService, protected menuService: MenuService) {}

    ngOnInit() {
        this.api.userInfo.subscribe(userInfo => this.userInfo = userInfo);
    }

    protected readonly AccountType = AccountType
}
